import React from "react";
import * as _ from "lodash";

export function renderProfileTabs(definition) {
	const visibleTabs = definition.filter(
		(tab) => !tab.hidden || tab.hidden === false,
	);

	return visibleTabs.map((tab) => {
		const { title, content } = tab;

		return {
			id: _.camelCase(title),
			title,
			content: React.createElement(content, { title }),
		};
	});
}
